import { useEffect } from "react";
import { motion } from "framer-motion";
import cryptography from "../img/cryptography.png";
import secureData from "../img/secureData.png";
import dataBro from "../img/data-bro.png";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import CourseDetail31 from "../components/CourseDetail31";
import CourseDetail32 from "../components/CourseDetail32";

const Crypto = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["數論與密碼學"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "用 Python 或 JavaScript （二擇一）來學習數論與密碼學，學會近代加密與驗證系統的演算法，包含訊息驗證、數位簽章、DES、AES、橢圓曲線密碼學、RSA 加密系統、密鑰交換，以及其他資安金鑰系統！",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={cryptography} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/cryptography-python/?couponCode=${process.env.REACT_APP_CRYPTOGRAPHY_COUPON}`}
              >
                <span>{process.env.REACT_APP_CRYPTOGRAPHY_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/cryptography-python/?couponCode=${process.env.REACT_APP_CRYPTOGRAPHY_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/cryptography-python
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/1594/about
            </p> */}
          </div>
        </div>
        <CourseDetail31 img={secureData} />
        <CourseDetail32 img={dataBro} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default Crypto;
